import React, { useEffect, useState } from 'react'
import './header.css'
import { Badge, Col, Layout, Menu, Row } from 'antd'
import { connect } from 'react-redux'
import { Link, useLocation, useHistory } from 'react-router-dom'

import { PropTypes } from 'prop-types'
import logo from '../../logo.png'
import PhysioAvatar from './avatar'
import TestClinicTag from '../common/testclinic.tag'
import { constants } from '../../constants'
import util from '../../util/util'
import serviceInterface from '../../services/service.interface'
import {
  loginAsCustomer,
  loginAsCompany,
} from '../../store/action/profile.action'
import { isEventUpdated,getDifference } from '../../store/action/event.action'
import { setPatient } from '../../store/action/patient.action'
import {
  fechactioncase,
  isNewActionCase,
} from '../../store/action/actioncases.action'
import { useSubscription } from '@apollo/client'
import NotificationBell from '../notification/bell'
import RemainderNotification from '../notification/remainder.notification'
import LiteNotification from '../../admin-lite/components/lite.notification'

var { ROLE } = constants

const ONLY_ADMINS = [ROLE.ADMIN, ROLE.COMPANY_ADMIN, ROLE.SUPER_ADMIN]

const { Header } = Layout

const Menubar = (props) => {
  var location = useLocation()
  var history = useHistory()
  let isAdminLite=location?.search==constants.ADMIN_LITE;
  const [currentLocation, setLocation] = useState()
  useEffect(() => {
   if(!props.company){
    props.isEventUpdated({
      customer: props.customer?._id,
      company: props.company?._id || props.customer?.company,
    })
    props.getDiffs({
        customer: props.customer?._id,
        company: props.company?._id,
      })
    }
    let filter = {}
    if (props?.customer?._id) filter.customerIds = [props?.customer?._id]
    if (props?.customer?._id) {
      props.isNewActionCase(props.customer._id, props.user?.surgeon)
    }
    if (props?.company?._id) {
      props.isNewActionCase(null, props.user?.surgeon, props?.company?._id)
    }
  }, [])

  useEffect(() => {
    setLocation(location)
    console.log(location)
  }, [location])

  var currentMenuKey = (key) => {
    if (location.pathname.search(key) >= 0) {
      return location.pathname
    } else {
      return key
    }
  }

  var verifyRoles = (roles = []) => {
    if (roles.length == 0) return true
    return serviceInterface.AuthService().authorize_role(roles, props.decoded)
  }


  var handleCustomersClick = () => {
    props.loginAsCompany(props.company)
    history.push('/customers')
  }

  var handleCompanyUsersClick = () => {
    history.push('/cusers')
  }
  var handleFulfillment = () => {
    history.push('/fulfillment')
  }

  // Handle logo click for company users to return to dashboard
  var handleLogoClick = () => {
    // Check if user is COMPANY_ADMIN or COMPANY_HEALTHCOACH
    if (verifyRoles([ROLE.COMPANY_ADMIN, ROLE.COMPANY_HEALTHCOACH])) {
      // Log out of customer context by logging back as company
      props.loginAsCompany(props.company)
      // Navigate to dashboard (home for company users)
      history.push('/dashboard')
    }
  }
  return (
    <>
    {isAdminLite?<><LiteNotification/></>:<>
      <Header className='header'>
        <div className='flex'>
          <div className='left'>
            <Row
              justify='end'
              hidden={
                verifyRoles([ROLE.COMPANY_ADMIN, ROLE.COMPANY_HEALTHCOACH, ROLE.SUPER_ADMIN])
              }
            >
              {props.customerLogo && (
                <Col
                  span={24}
                  flex={'none'}
                  className='customerLogo'
                  style={{ maxHeight: 'fit-content' }}
                >
                  <img src={props.customerLogo} />
                </Col>
              )}
              <Col
                className={'customerHeader customerName ' + (props.customerLogo ? '' : 'largFont')}
              >
                <div className='customerNameLine' style={{ lineHeight: props.customerLogo?2:1.3,marginTop:0 }}>
                  <span className='customerNameText'>{props.customer?.name}</span>
                  <TestClinicTag isTest={props.customer?.istestclinic} />
                </div>
                {props.customer &&<div className="clinicCode" style={{ lineHeight: 1 }}>Clinic Code: {props.customer?.accesscode}</div>}
              </Col>
            </Row>
          </div>
          <div className='inlineFlexRight' style={{ flex: '1', minWidth: '0' }}>
            {/* <div hidden={!props.customer} className="menu"> */}
            <div className='logoAvtar'>
              <div className='menu' style={{ marginLeft: 'auto' }}>
                <Menu
                  key={props.customer}
                  theme='dark'
                  mode='horizontal'
                  disabledOverflow={true}
                  selectedKeys={[location.pathname]}
                  defaultSelectedKeys={[location.pathname]}
                  style={{ minWidth: '600px' }}
                >
                  {verifyRoles([
                    ROLE.ADMIN,
                    ROLE.PHYSIO,
                    ROLE.MEDICAL_ASSOCIATE,
                  ]) && (
                    <Menu.Item key={currentMenuKey('/compliance')}>
                      <Link to='/compliance'>Home</Link>
                    </Menu.Item>
                  )}
                  {verifyRoles([
                    ROLE.ADMIN,
                    ROLE.PHYSIO,
                    ROLE.MEDICAL_ASSOCIATE,
                  ]) && (
                    <Menu.Item key={currentMenuKey('/surgeons')}>
                      {' '}
                      <Link to='/surgeons'>Providers</Link>
                    </Menu.Item>
                  )}
                  {verifyRoles([ROLE.SURGEON]) && (
                    <Menu.Item key={currentMenuKey('/profile')}>
                      {' '}
                      <Link to='/profile/?myprofile=true'>Profile</Link>
                    </Menu.Item>
                  )}
                  {verifyRoles([
                    ROLE.SURGEON,
                    ROLE.ADMIN,
                    ROLE.PHYSIO,
                    ROLE.MEDICAL_ASSOCIATE,
                  ]) &&
                    (props.user?.role == ROLE.SURGEON
                      ? props.user?.patients_count > 0
                      : true) && ( // hide the patients if surgeon doesn't has any patients
                      <Menu.Item key={currentMenuKey('/patient')}>
                        <Link onClick={props.setPatient} to='/patient'>
                          Patients
                        </Link>
                      </Menu.Item>
                    )}
                  {verifyRoles([ROLE.ADMIN]) && (
                    <Menu.Item key={currentMenuKey('/users')}>
                      <Link to='/users'>Users</Link>
                    </Menu.Item>
                  )}
                  {verifyRoles([
                    ROLE.COMPANY_ADMIN,
                    ROLE.COMPANY_HEALTHCOACH,
                  ]) && !props.customer?._id && (
                    <Menu.Item key={currentMenuKey('/dashboard')}>
                      <Link to='/dashboard'>Home</Link>
                    </Menu.Item>
                  )}
                  {verifyRoles([ROLE.COMPANY_ADMIN]) &&
                    !props.customer?._id && (
                      <Menu.Item
                        onClick={handleFulfillment}
                        key={currentMenuKey('/fulfillment')}
                      >
                        Fullfillment
                      </Menu.Item>
                    )}
                  {verifyRoles([
                    ROLE.COMPANY_ADMIN,
                    ROLE.COMPANY_HEALTHCOACH,
                  ]) && (
                    <Menu.Item
                      onClick={handleCustomersClick}
                      key={currentMenuKey('/customers')}
                    >
                      Clinics
                    </Menu.Item>
                  )}
                  {verifyRoles([ROLE.COMPANY_ADMIN]) &&
                    !props.customer?._id && (
                      <Menu.Item
                        onClick={handleCompanyUsersClick}
                        key={currentMenuKey('/cusers')}
                      >
                        Company users
                      </Menu.Item>
                    )}
                  {verifyRoles([
                    ROLE.COMPANY_ADMIN,
                    ROLE.COMPANY_HEALTHCOACH,
                  ]) &&
                    !props.customer?._id && (
                      <Menu.Item
                        key={currentMenuKey('/cases')}
                        className='remainder-header'
                      >
                        <Row>
                          <Link to='/cases'>Cases</Link>
                          <NotificationBell
                            customerId={props?.customer?._id || ''}
                            companyId={
                              props.customer?.company ||
                              props.company?._id ||
                              null
                            }
                          />
                        </Row>
                      </Menu.Item>
                    )}
                  {verifyRoles([ROLE.ADMIN]) && (
                    <Menu.Item key={'/notification'}>
                      <Link to='/notification'>
                        {/* {props.isNew?<Row>
                            <Col >Messages</Col>
                            <Col><Badge count={1}  size='small' offset={[0,-15]} ></Badge></Col>
                        </Row>:("Messages")} */}
                        <Row>
                          <Col>Messages</Col>
                          <NotificationBell
                            customerId={props.customer?._id || ''}
                          />
                        </Row>
                      </Link>
                    </Menu.Item>
                  )}
                  {/* TEMP FIX: Removed ROLE.MEDICAL_ASSOCIATE from Messages menu.
                      To revert: change verifyRoles([ROLE.SURGEON]) back to verifyRoles([ROLE.SURGEON, ROLE.MEDICAL_ASSOCIATE]) */}
                  {verifyRoles([ROLE.SURGEON]) && (
                    <Menu.Item key={'/inbox'}>
                      <Link to='/inbox'>Messages</Link>
                    </Menu.Item>
                  )}
                  {verifyRoles([ROLE.SUPER_ADMIN]) && (
                    <Menu.Item key={'/companies'}>
                      <Link to='/companies'>Companies</Link>
                    </Menu.Item>
                  )}
                  {verifyRoles([ROLE.SUPER_ADMIN]) && (
                    <Menu.Item key={'/systemmaintenance'}>
                      <Link to='/systemmaintenance'>System</Link>
                    </Menu.Item>
                  )}
                  {verifyRoles([
                    ROLE.COMPANY_ADMIN,
                    ROLE.COMPANY_HEALTHCOACH,
                    ROLE.SUPER_ADMIN,
                  ]) && (
                    <Menu.SubMenu key={'settings'} title='Settings'>
                      {verifyRoles([ROLE.COMPANY_ADMIN, ROLE.SUPER_ADMIN]) && (
                        <Menu.Item key={'/exerciselibrary'}>
                          <Link to='/exerciselibrary'>Exercise Library</Link>
                        </Menu.Item>
                      )}
                      {verifyRoles([ROLE.COMPANY_ADMIN, ROLE.SUPER_ADMIN]) && (
                        <Menu.Item key={'/supportprofile'}>
                          <Link to='/supportprofile'>Support Profile</Link>
                        </Menu.Item>
                      )}
                      {/* The company's default care plan — what a NEW clinic is
                          created from (devices, exercises, questionnaires,
                          TracPatch settings, goals, reminders). Company context
                          only; a selected clinic has its own Settings page. */}
                      {verifyRoles([ROLE.COMPANY_ADMIN, ROLE.COMPANY_HEALTHCOACH]) &&
                        !props.customer?._id && (
                          <Menu.Item key={'/companysettings'}>
                            <Link to='/companysettings'>Company Care Plan</Link>
                          </Menu.Item>
                        )}
                      {/* Company-wide default reminders live under Settings; the
                          clinic-scoped list lives in the Clinic Settings page. */}
                      {!props.customer?._id && (
                        <Menu.Item key={'/events'}>
                          <Link to='/events'>Reminders</Link>
                        </Menu.Item>
                      )}
                    </Menu.SubMenu>
                  )}
                  {/* {verifyRoles([ROLE.ADMIN])    && <Menu.Item key={"/compliance"}><Link to="/compliance">Compliance</Link></Menu.Item>} */}
                  {/* Clinic-admin direct logins keep a top-level Reminders entry —
                      they have no Clinic Settings page. Company/super admins reach
                      reminders via Settings (company) or Clinic Settings (clinic). */}
                  {verifyRoles([ROLE.ADMIN]) && (
                    <Menu.Item key={'/events'} className='remainder-header'>
                      {location.pathname == '/events' ? (
                        <Link to='/events'>Reminders</Link>
                      ) : (
                        <Badge count={props.eventupdated ? 1 : 0} size='small'>
                          <Link to='/events'>Reminders</Link>
                        </Badge>
                      )}
                      <RemainderNotification
                        customerId={props.customer?._id || ''}
                        companyId={
                          props.customer?.company || props.company?._id || null
                        }
                      />
                    </Menu.Item>
                  )}
                  {verifyRoles([
                    ROLE.ADMIN,
                    ROLE.PHYSIO,
                    ROLE.MEDICAL_ASSOCIATE,
                  ]) && (
                    <Menu.Item key={currentMenuKey('/support')}>
                      <Link to='/support'>Support</Link>
                    </Menu.Item>
                  )}
                </Menu>
              </div>

              <div
                className='logo'
                onClick={handleLogoClick}
                style={{
                  cursor: verifyRoles([ROLE.COMPANY_ADMIN, ROLE.COMPANY_HEALTHCOACH]) ? 'pointer' : 'default'
                }}
                title={verifyRoles([ROLE.COMPANY_ADMIN, ROLE.COMPANY_HEALTHCOACH]) ? 'Return to Dashboard' : ''}
              >
                <img src={logo} />
              </div>
              {props.user && (
                <div>
                  <PhysioAvatar />
                </div>
              )}
            </div>
          </div>
        </div>
      </Header>
      <Header
        hidden={
          !(
            verifyRoles([ROLE.COMPANY_ADMIN, ROLE.COMPANY_HEALTHCOACH]) &&
            props.customer?._id
          )
        }
        className='header-light'
      >
        <Row style={{ display: 'flex', float: 'left' }}>
          {props.customerLogo && (
            <div
              span={24}
              className='customerLogo'
              style={{ maxHeight: '20px' }}
            >
              <img src={props.customerLogo} />
            </div>
          )}
          <div
            className={'customerName ' + (props.customerLogo ? '' : 'largFont')}
          >
 <div style={{ lineHeight: props.customerLogo?2:1.3,marginTop:0 }}>{props.customer?.name}</div>
                {props.customer &&<div className="clinicCode" style={{ lineHeight: 1 }}>Clinic Code: {props.customer?.accesscode}</div>}
          </div>
        </Row>
        <div className='inlineFlexRight' style={{ backgroundColor: 'inherit' }}>
          {/* <div hidden={!props.customer} className="menu"> */}
          <div className='menu' style={{ marginLeft: 'auto', minWidth: '800px' }}>
            <Menu
              theme='dark'
              mode='horizontal'
              disabledOverflow={true}
              selectedKeys={[location.pathname]}
              defaultSelectedKeys={[location.pathname]}
            >
              {verifyRoles(ONLY_ADMINS) && (
                <Menu.Item key={currentMenuKey('/compliance')}>
                  {' '}
                  <Link to='/compliance'>Home</Link>
                </Menu.Item>
              )}
              {verifyRoles(ONLY_ADMINS) && (
                <Menu.Item key={currentMenuKey('/surgeons')}>
                  {' '}
                  <Link to='/surgeons'>Providers</Link>
                </Menu.Item>
              )}
              {verifyRoles(ONLY_ADMINS) && (
                <Menu.Item key={currentMenuKey('/users')}>
                  <Link to='/users'>Users</Link>
                </Menu.Item>
              )}

              {verifyRoles(ONLY_ADMINS.concat([ROLE.COMPANY_HEALTHCOACH])) && (
                <Menu.Item key={currentMenuKey('/patient')}>
                  <Link to='/patient'>Patients</Link>
                </Menu.Item>
              )}
              {verifyRoles(ONLY_ADMINS.concat([ROLE.COMPANY_HEALTHCOACH])) && props.customer?._id && (
                <Menu.Item key={'/notification'}>
                  <Link to='/notification'>
                    <Row>
                      <Col>Messages</Col>
                      <NotificationBell
                        customerId={props.customer?._id || ''}
                      />
                    </Row>
                  </Link>
                </Menu.Item>
              )}
              {/* Clinic reminders moved into the Clinic Settings page (below
                  Clinic's Care Plan) — no top-level Reminders entry here. */}
              {verifyRoles([ROLE.COMPANY_ADMIN, ROLE.COMPANY_HEALTHCOACH]) &&
                props.customer?._id && (
                  <Menu.Item key={currentMenuKey('/clinicsettings')}>
                    <Link to='/clinicsettings'>Settings</Link>
                  </Menu.Item>
                )}
            </Menu>
          </div>
          <div style={{ visibility: 'hidden' }} className='logo submenu'>
            <img src={logo} />
          </div>
          <div style={{ visibility: 'hidden' }} className='submenu'>
            <PhysioAvatar />
          </div>
        </div>
      </Header>
      </>
    }
    </>
  )
}

Menubar.propTypes = {
  customerLogo: PropTypes.string,
  isAdmin: PropTypes.bool,
}

const mapStateToProps = (state) => {
  return {
    customerLogo: state.profile.customer ? state.profile.customer.logo : '',
    isAdmin: state.profile?.role == constants.ROLE.ADMIN,
    decoded: util.verifyToken(state.profile.token, true),
    customer: state.profile.customer,
    company: state.profile.company,
    isNew: state.message.isNew,
    user: state.profile.user,
    actioncases: state.actioncase.actioncases,
    eventupdated: state.event.isUpdated,
    singleMsg: state.actioncase.singleMsg,
    patientAndMsg: state.actioncase.patientAndMsg,
    profile: state.profile,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    loginAsCustomer: (customer) => dispatch(loginAsCustomer(customer)),
    loginAsCompany: (company) => dispatch(loginAsCompany(company)),
    isEventUpdated: (params) => dispatch(isEventUpdated(params)),
    getDiffs: (params) => dispatch(getDifference(params)),
    fechactioncase: (params) => dispatch(fechactioncase(params)),
    isNewActionCase: (customer, surgeonId, companyId) =>
      dispatch(isNewActionCase(customer, surgeonId, companyId)),
    setPatient: () => dispatch(setPatient({})),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Menubar)
